module.exports = __webpack_public_path__ + "img/visivel-produto.3fde5cf1.svg";